import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Wallace extends Lit3formBlock {
  static get characterName() {
    return 'wallace';
  }

  static get characterProperties() {
    return {
      subheader: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid wallace-layout">
          <div class="wallace-columns">
            ${this.headerColumnHTML} ${this.rowsColumnHTML}
            ${this.descriptionColumnHTML} ${this.ctasColumnHTML}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerColumnHTML() {
    return html`
      <div class="column header-column">
        ${this.headerText
          ? html`
              <h2 class="header">${unsafeHTML(this.headerText)}</h2>
            `
          : html``}
        ${this.subheaderText
          ? html`
              <p class="subheader">${unsafeHTML(this.subheaderText)}</p>
            `
          : html``}
        ${this.imageSrc
          ? html`
              <div class="sample-image">
                <img src=${this.imageUrl} alt="" />
              </div>
            `
          : html``}
        ${this.headerCtaData
          ? html`
              <cta-button
                class="header-cta"
                cta-data=${JSON.stringify(this.headerCtaData)}
                cta-type="primary"
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  this.headerCtaData,
                  this.headerText
                )}
              ></cta-button>
            `
          : html``}
      </div>
    `;
  }

  get rowsColumnHTML() {
    if (!this.rows.length && !this.content.details_heading) return html``;
    return html`
      <div class="column rows-column">
        ${this.content.details_heading
          ? html`
              <h4 class="section-heading">${this.content.details_heading}</h4>
            `
          : html``}
        <div class="column-content">
          ${this.rows.map(
            row => html`
              <div class="row">
                ${row.header
                  ? html`
                      <p class="row-header">${unsafeHTML(row.header)}</p>
                    `
                  : html``}
                ${row.text
                  ? html`
                      <p class="row-body">${unsafeHTML(row.text)}</p>
                    `
                  : html``}
              </div>
            `
          )}
        </div>
      </div>
    `;
  }

  get descriptionColumnHTML() {
    if (
      !this.content.description_heading &&
      !this.content.description_text &&
      !this.content.downloads_heading &&
      !this.downloadLinks.length
    ) {
      return html``;
    }
    return html`
      <div class="column description-column">
        ${this.content.description_heading
          ? html`
              <h4 class="section-heading">
                ${this.content.description_heading}
              </h4>
            `
          : html``}
        ${this.content.description_text
          ? html`
              <p class="description-body">
                ${unsafeHTML(
                  this.withLineBreaks(this.content.description_text)
                )}
              </p>
            `
          : html``}
        ${this.downloadLinks.length
          ? html`
              ${this.content.downloads_heading
                ? html`
                    <h4 class="section-heading downloads-heading">
                      ${this.content.downloads_heading}
                    </h4>
                  `
                : html``}
              <div class="downloads">
                ${this.downloadLinks.map(
                  link => html`
                    <cta-text
                      class="download-link"
                      cta-data=${JSON.stringify(link)}
                      hide-right-arrow-svg="true"
                      left-download-svg="true"
                      target-blank="true"
                      .ctaAnalyticsData=${analyticsCtaDataObject(
                        link,
                        this.headerText
                      )}
                    ></cta-text>
                  `
                )}
              </div>
            `
          : html``}
      </div>
    `;
  }

  get ctasColumnHTML() {
    if (!this.ctaButtons.length && !this.content.ctas_heading) return html``;
    return html`
      <div class="column ctas-column">
        ${this.content.ctas_heading
          ? html`
              <h4 class="section-heading">${this.content.ctas_heading}</h4>
            `
          : html``}
        <div class="cta-stack">
          ${this.ctaButtons.map(
            cta => html`
              <cta-button
                cta-data=${JSON.stringify({ ...cta, fullWidth: true })}
                cta-type=${this.ctaType(cta)}
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  cta,
                  this.headerText
                )}
              ></cta-button>
            `
          )}
        </div>
      </div>
    `;
  }

  ctaType(cta) {
    if (cta.type === 'primary_button' || cta.type === 'Primary button') {
      return 'primary';
    }
    return 'secondary';
  }

  get subheaderText() {
    return this.withLineBreaks(this.content.subheader) || '';
  }

  get headerCtaData() {
    const text = this.content.header_cta_text;
    const url = this.content.header_cta_url;
    if (!text) return null;
    return { text, url: url || '', fullWidth: true };
  }

  get imageSrc() {
    return this.content.image?.src;
  }

  get imageUrl() {
    return this.imagebossUrl(this.imageSrc, 440);
  }

  get rows() {
    return this.content.rows || [];
  }

  get downloadLinks() {
    return this.content.download_links || [];
  }

  get ctaButtons() {
    return this.content.cta_buttons || [];
  }
}
Wallace.defineElement();
